<template>
	<div class="login-container">
		<div style="position: absolute;top: -100%;left: -100%;">
			<input type="text" autocomplete="off">
			<input type="password" autocomplete="new-password">
			<input type="text" autocomplete="off">
		</div>
		<div class="login-container-bg">
			<div class="login-content">
				<login-header></login-header>
				<div class="login-box">
					<div class="register-box-item-title box flex-justify-between">
						<p class="register-box-title color-primary">修改密码</p>
						<p class="text-secondary">
							已有账号？<span class="color-primary cursor-pointer" @click="skip('/login')">马上登录。</span>
							没有账号？<span class="color-primary cursor-pointer" @click="skip('/register')">去注册。</span>
						</p>
					</div>
					<div class="login-box-item">
						<efly-tooltip class="box flex-column" style="width: 100%;text-align:left;" :content="errorMsg.phone"
										:trigger="errorMsg.phone ? 'show' : 'hide'" type="danger"
										position="absolute" top="2px" left="366px"
										placement="right">
							<div class="box">
								<efly-input size="default" type="text" width="100%" prefix-icon="icon-email" placeholder="手机号码"
											v-model="status.phone" @blur="checkInput('phone')"></efly-input>
							</div>
						</efly-tooltip>
					</div>
					<div class="login-box-item">
						<efly-tooltip class="box flex-column" style="width: 100%;text-align:left;" :content="errorMsg.vscode"
										:trigger="errorMsg.vscode ? 'show' : 'hide'" type="danger"
										position="absolute" top="2px" left="366px"
										placement="right">
							<div class="box">
								<efly-input size="default" type="text" width="60%" prefix-icon="icon-key" placeholder="请输入验证码"
											v-model="status.vscode" autocomplete="off"></efly-input>
								<div class="vscode cursor-pointer">
									<efly-button size="small" class="btn-outline-primary" @click="getVscode()" v-if="loading.vscode === ''">获取验证码</efly-button>
									<efly-button size="small" class="btn-outline-primary" v-if="loading.vscode === 'loading'">发送中...</efly-button>
									<efly-button size="small" class="btn-outline-primary" :disabled="true" v-if="loading.vscode === 'havedata'">重新发送({{status.countDown}})</efly-button>
								</div>
							</div>
						</efly-tooltip>
					</div>
					<div class="login-box-item">
						<efly-tooltip class="box flex-column" style="width: 100%;text-align:left;"
										:trigger="errorMsg.password ? 'show' : 'hide'" type="danger"
										position="absolute" :top="errorMsg.password.length > 19 ? '-5px' : '2px'" left="366px"
										placement="right">
							<div slot="content">
								<p class="break-wrod">{{errorMsg.password.slice(0, 19)}}</p>
								<p class="break-wrod" v-if="errorMsg.password.length > 19">{{errorMsg.password.slice(19)}}</p>
							</div>
							<div class="box">
								<efly-input size="default" type="password" width="100%" prefix-icon="icon-lock" placeholder="请输入新密码(8~个32字符)"
											v-model="status.password" @blur="checkInput('password')" autocomplete="off"></efly-input>
							</div>
						</efly-tooltip>
					</div>
					<div class="login-box-item">
						<efly-tooltip class="box flex-column" style="width: 100%;text-align:left;" :content="errorMsg.confirmPassword"
										:trigger="errorMsg.confirmPassword ? 'show' : 'hide'" type="danger"
										position="absolute" top="2px" left="366px"
										placement="right">
							<div class="box">
								<efly-input size="default" type="password" width="100%" prefix-icon="icon-lock" placeholder="请再次输入新密码(8~个32字符)"
											v-model="status.confirmPassword" @blur="checkInput('confirmPassword')"></efly-input>
							</div>
						</efly-tooltip>
					</div>
					<!-- <div class="login-box-item">
						<efly-tooltip class="box flex-column" style="width: 100%;text-align:left;" :content="errorMsg.phone"
										:trigger="errorMsg.phone ? 'show' : 'hide'" type="danger"
										position="absolute" top="2px" left="366px"
										placement="right">
							<div class="box">
								<efly-input size="default" type="text" width="100%" prefix-icon="icon-phone2" placeholder="手机号码"
											v-model="status.phone" @blur="checkInput('phone')"></efly-input>
							</div>
						</efly-tooltip>
					</div> -->

					<div class="login-box-item">
						<efly-button size="default" class="btn-primary" style="width: 100%;" @click="submit()" v-show="status.loading !== 'loading'">确&nbsp;&nbsp;&nbsp;&nbsp;定</efly-button>
						<efly-button size="default" class="btn-primary" style="width: 100%;" v-show="status.loading === 'loading'"><img src="../../../../common/src/assets/image/login-loading.gif" alt=""></efly-button>
					</div>
				</div>

				<login-footer :type="'ecp'"></login-footer>
			</div>
		</div>

		<sliding-verification-code :phone="status.phone" type="forgetPassword" :show="component.code" @success="vscodeChange()"></sliding-verification-code>
	</div>
</template>

<script>
    import ResetPassword from "./reset-password";

    export default ResetPassword;
</script>
<style lang="scss">
	.login-box-item {
		.efly-input,input,.efly-button {
			border-radius: 3px;
			height: 44px;
		}
		.efly-input .icon {
			color: #BDBDBD;
			font-size: 14px;
		}
		.efly-input input{
			color: #555;
		}
		.efly-button {
			font-size: 18px;
		}
	}
</style>
<style lang="scss" scoped>
.login-container {
	width: 100%;
	height: 100%;
	min-width: 1200px;
	box-sizing: border-box;
	* {box-sizing: border-box;}

	.login-container-bg {
		width: 100%;
		height: 100%;
		background: url('../../assets/image/login-bg.png') no-repeat;
		background-color: #EBF2FA;
		position: relative;

		.login-content {
			width: 100%;
			height: 100%;
			text-align: center;
			// background: url('../../assets/image/login-box.png') top center no-repeat;
			// background-size: 1800px;

			.login-logo {
				padding-top: 100px;
				text-align: center;
			}

			.login-box {
				width: 1030px;
				height: 555px;
				margin: auto;
				position: absolute;
				top: 0;
				left: 0;
				right: 0;
				bottom: 0;
				background: url('../../assets/image/register-box.png') 107% 110% no-repeat;
				background-color: #fff;
				box-shadow: 0px 0px 16px 0px rgba(0,0,0,0.12);
				text-align: center;


				.register-box-item-title {
					display: flex;
					justify-content: space-between;
					line-height: 70px;
					margin: 0 30px;
					box-sizing: border-box;
					border-bottom: 1px solid #DCDCDC;
					margin-bottom: 80px;

					.register-box-title {
						margin: 0;
						font-size: 20px;
					}
				}
				.login-box-item {
					width: 358px;
					margin: auto;
					// margin-right: 0;
					// margin-left: auto;
					margin-bottom: 20px;


					.vscode {
						width: 40%;
						margin-left: 5px;

						img {
							width: 100%;
							height: 100%;
						}

						button {
							font-size: 14px;
							width: 100%;
							background: #E8F6FF;
							&:hover {
								color: #009FEF !important;
								opacity: 0.9;
							}
						}
					}
				}
			}
		}
	}
}
.break-wrod {
	word-wrap: break-word;
}
</style>
